module.exports = __webpack_public_path__ + "img/SmallGunsBook.91ca0d53.png";